import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'mentions-legales',
    templateUrl: './mentions-legales.component.html',
    styleUrls: ['./mentions-legales.component.scss']
})
export class MentionsLegalesComponent implements OnInit{
    ngOnInit(): void {
        window.scrollTo(0, 0);
    }
}